<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="checkin-member"
          :title="title"
          :url="url"
          :filter="filter"
          :columns="columns"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        >
        <template v-slot:action>
            <v-col md="3">
              <v-autocomplete
                label="Member"
                required
                dense
                outlined
                v-model="filterMember"
                :items="listMembers"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col md="3">
              <v-autocomplete
                label="Personal Trainer"
                required
                dense
                outlined
                v-model="filterPersonalTrainer"
                :items="listPersonalTrainers"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col md="3">
              <date-picker
                placeholder="Tanggal"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterDateStart"
              ></date-picker>
            </v-col>
            <!-- <v-col md="3">
              <date-picker
                placeholder="Sampai Tanggal"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterDateEnd"
              ></date-picker>
            </v-col> -->
          </template>
        <template v-slot:[`item.checkin_date`]="{ item }">
            <div v-if="item.checkin_date != null">
              {{ item.checkin_date | moment("DD/MM/YYYY") }}
            </div>
            <div v-else>-</div>
          </template>
      </datatable>
      </div>
    </div>
    <form-data ref="form" module="checkin-member" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="checkin-member"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormData from "./Form";
import Moment from "moment";
import ApiService from "@/core/services/api.service";

export default {
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Member", route: "" },
      { title: "Checkin Member" }
    ]);

    const members = await ApiService.get("user/list?role_slug=member");
    this.listMembers = members.data;

    const personalTrainers = await ApiService.get("user/list?role_slug=personal-trainer");
    this.listPersonalTrainers = personalTrainers.data;

  },
  data() {
    return {
      title: "Checkin Member",
      url: "checkin-member/data",
      filter: null,
      filterSlug: null,
      filterMember: null,
      filterPersonalTrainer: null,
      filterDateStart: null,
      filterDateEnd: null,
      listMembers: [],
      listPersonalTrainers: [],
      columns: [
        {
          value: "id"
        },
        {
          text: "Tanggal",
          value: "checkin_date",
          sortable: true,
          searchable: false
        },
        {
          text: "Jam Mulai",
          value: "start_time",
          sortable: true,
          searchable: true
        },
        {
          text: "Member",
          value: "member_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Personal Trainer",
          value: "personal_trainer_name",
          sortable: true,
          searchable: true
        },
      ]
    };
  },
  methods: {
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    },
    filterBy() {
      let finalFilter = [];

      if (this.filterMember) {
        finalFilter = [
          ...finalFilter,
          {
            column: "member_id",
            value: this.filterMember,
          }
        ];
      }
      if (this.filterPersonalTrainer) {
        finalFilter = [
          ...finalFilter,
          {
            column: "personal_trainer_id",
            value: this.filterPersonalTrainer,
          }
        ];
      }
      if (this.filterDateStart) {
        finalFilter = [
          ...finalFilter,
          {
            column: "checkin_date",
            value: Moment(this.filterDateStart, "DD/MM/YYYY").format("YYYY-MM-DD"),
            // operator:"gte"
          }
        ];
      }
      if (this.filterDateEnd) {
        finalFilter = [
          ...finalFilter,
          {
            column: "checkin_date",
            value: Moment(this.filterDateEnd, "DD/MM/YYYY").format("YYYY-MM-DD"),
            operator:"lte"
          }
        ];
      }

      if (finalFilter.length > 0) {
        this.filter = finalFilter;
      } else {
        this.filter = null;
        this.filterSlug = null;
      }
    },
  },
  watch: {
    filterMember(v) {
      if (v) {
        this.filterMember = v;
      } else {
        this.filterMember = null;
      }

      this.filterBy();
    },
    filterPersonalTrainer(v) {
      if (v) {
        this.filterPersonalTrainer = v;
      } else {
        this.filterPersonalTrainer = null;
      }

      this.filterBy();
    },
    filterDateStart(v) {
      if (v) {
        this.filterDateStart = v;
      } else {
        this.filterDateStart = null;
      }
      this.filterBy();
    },
    filterDateEnd(v) {
      if (v) {
        this.filterDateEnd = v;
      } else {
        this.filterDateEnd = null;
      }
      this.filterBy();
    }
    
  },
  components: {
    Datatable,
    DeleteDialog,
    FormData
  }
};
</script>
